"use client";

import React, { FC, type PropsWithChildren } from "react";
import SelectLanguageWidget from "~components/widget/select-language-widget";

const UnauthorizedLayout: FC<
  PropsWithChildren & {
    locale: string;
  }
> = ({ children, locale }) => {
  return (
    <div className="flex justify-center h-screen relative">
      <SelectLanguageWidget
        locale={locale}
        className="bg-dark absolute top-10 right-10"
      />
      <div className="w-full max-w-[500px]">{children}</div>
      <div className="text-white/30 text-center bottom-4 absolute">
        ©2024 LBC66 Gaming. All rights reserved.
      </div>
    </div>
  );
};

export default UnauthorizedLayout;
